import { useContext, useMemo } from 'react'

import { isArray, isFunction } from 'lodash'

import { GlobalContext } from '../../../../Providers/GlobalProvider'
import EntitiesSelector from '../EntitiesSelector'
import { isObject } from '../../../../utils'
import { InstitutionModalContext } from '../../../../Providers/Forms/InstitutionModal/InstitutionModal'
import { InstitutionGroupContext } from '../../../../Providers/InstitutionGroupProvider'

const InstitutionsSelector = ({
  className = '', disabled, dropdownRender, empty = false, institutions = [], multiple = 'default', placeholder = '', reverse = false, style = {}, values, onChange
}) => {
  const gc = useContext(GlobalContext)
  const modalContext = useContext(InstitutionModalContext)
  const ig = useContext(InstitutionGroupContext)

  const institutionEntities = useMemo(() => {
    let institutionEntities = []

    if (isArray(institutions) && institutions.length > 0) {
      institutionEntities = institutions
    } else if (isObject(ig)) {
      institutionEntities = ig.institutions
    } else if (isObject(gc)) {
      institutionEntities = gc.institutions
    }

    return institutionEntities.filter(i => isObject(i) && i.id !== null && i.id !== undefined)
  }, [institutions, gc, ig])

  const institutionsOptions = useMemo(() => institutionEntities.map(institution => {
    const values = {
      label: institution.acronym ?? institution.name,
      value: institution.id,
      tooltip: institution.name,
      entity: institution
    }

    if (reverse) {
      values.stored = values.label
      values.label = values.tooltip
      values.tooltip = values.stored
      delete values.stored
    }

    return values
  }), [institutionEntities])

  return (
    <div className={className}>
      <EntitiesSelector
        disabled={disabled}
        empty={empty}
        entityOptions={institutionsOptions}
        multiple={multiple}
        placeholder={placeholder}
        showSearch
        style={style}
        values={values}
        dropdownRender={modalContext !== undefined && isFunction(dropdownRender) ? dropdownRender(modalContext.setFormHandler) : undefined}
        onChange={onChange}
      />
    </div>
  )
}

export default InstitutionsSelector
